import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { OFERTA_BASE_ROUTES } from './oferta-base.routes';
import { syncRoutesWithFeature } from '../../../shared/routes/feature-routes.util';

export const OFERTAS_OFERTA_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    syncRoutesWithFeature(routesService, configState, 'cargo_fleet.AceitasRecusadas', [
      ...OFERTA_BASE_ROUTES,
    ]);
  };
}
